<template>
  <qx-card-form title="核赔信息" v-show="showComponent">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>
<script>
export default {
  data () {
    return {
      showComponent: false,
      baseForm: {
        isClosingCaseOptions: [],
        form: [
          { label: '核赔金额（元）', value: 'settAmt', type: 'input', disabled: false },
          { label: '核赔日期', value: 'compensationDate', type: 'date', attr: { type: 'datetime', time: '00:00:00' }, disabled: false },
          { label: '是否结案', value: 'isClosingCase', type: 'select', default: '-1', onChange: () => {this.isClosingCaseChange();} },
          { label: '结案时间', value: 'closingCaseDate', type: 'date', attr: { type: 'datetime', time: '00:00:00' }, hide: true },
          { label: '核赔账户', value: 'settAccount', type: 'input', disabled: false },
        ],
        rules: {
          settAmt: [
            { required: true, message: '请输入核赔金额（元）', trigger: 'blur' },
          ],
          compensationDate: [
            { required: true, message: '请选择核赔日期', trigger: 'blur' },
          ],
          closingCaseDate: [
            {required: false, message: '请选择结案时间', trigger: 'blur'},
          ],
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    setList (optionList) {
      this.baseForm.isClosingCaseOptions = optionList;
    },
    initSelect (data, selectFieldName) {
      if (data[selectFieldName] !== undefined) {
        data[selectFieldName] = String(data[selectFieldName]);
      }
    },
    isClosingCaseChange () {
      if (this.$refs.baseForm.getVal('isClosingCase') === '1') {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: ['closingCaseDate'],
        });

        this.baseForm.rules.closingCaseDate[0].required = true;
      } else {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: true,
          names: ['closingCaseDate'],
        });
        this.$refs.baseForm.setVal('closingCaseDate', '');
      }
    },
    // 显示和禁用逻辑
    showAndDisabledLogic (data) {
      this.showComponent = false;
      let formItemDisabled = false;

      if (data.accidentState === 4) {
        this.showComponent = true;
      }

      let accidentRegisterState = `${data.accidentState}`;
      if (this.$route.query.accidentRegisterState) {
        accidentRegisterState = `${this.$route.query.accidentRegisterState}`;
      }
      if (data.isClosingCase === 1) {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
        });
      }
      // 重置一下所有选项
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: false,
      });

      switch (accidentRegisterState) {
        case '1':
          // 事故登记
          break;
        case '2':
          // 定损登记
          break;
        case '3':
          // 维修登记
          break;
        case '4':
          // 理赔登记
          this.showComponent = true;
          if (data.busiCode !== undefined && data.busiCode !== '' && data.busiCode !== null && !this.$route.query.accidentRegisterState) {
            // 管理车辆费用
            // 只能修改是否结案
            formItemDisabled = true;
          }
          break;
        default:
          break;
      }
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: formItemDisabled,
        names: ['settAmt', 'compensationDate', 'settAccount'],
      });
      for (let name in this.baseForm.rules) {
        if (this.baseForm.rules[name]) {
          const rules = this.baseForm.rules[name];
          for (let item of rules) {
            // 如果组件不显示，则需要将必填项改为非必填，否则无法保存提交（因为会校验）
            item.required = this.showComponent;
          }
        }
      }
    },
    async handleSubData (cache) {
      let formData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        // 这里处理的格式必须和详情接口返回的一样
        formData.compensationDate = this.formatDate(formData.compensationDate, 1);
        formData.closingCaseDate = this.formatDate(formData.closingCaseDate, 1);
      }
      console.log('车辆核赔参数', formData);
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async sub () {
      const formData = await this.handleSubData();
      // console.log('提交参数', formData);
      return formData;
    },
    init (data = {}) {
      this.$refs.baseForm.reset();
      this.showAndDisabledLogic(data);
      this.initSelect(data, 'isClosingCase');
      this.$refs.baseForm.setVal(data);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
